goog.provide('el8.appchart.dialog.addEditIntolerance');

goog.require('el8.appshared.form.buttons');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.alert');
goog.require('el8.template.appchart.dialog.addEditIntolerance');
goog.require('el8.service.infoField');
goog.require('el8.util.consts');
goog.require('el8.data.allergies');
goog.require('el8.data.snomedCodes');
goog.require('el8.ptdata.ptIntolerances');
goog.require('el8.appshared.mindreaderOpts');

el8.appchart.dialog.addEditIntolerance = (function() {

    var currPtIntolerance = null;
    var selectedIntolerance = null;
    var selectedReaction = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Edit Drug Intolerance',
        autoHeight: true,
        width: 400,
        contentFn: function() {
            return el8.template.appchart.dialog.addEditIntolerance.form({
                statusChoices: el8.util.consts.ALLERGY_STATUS_CHOICES,
                severitySnomeds: el8.util.consts.ALLERGY_SEVERITY_SNOMEDS
            });
        }
    });

    var mindreaderOpts = el8.appshared.mindreaderOpts.allergies();
    mindreaderOpts['selectFn'] = function(event, item) {
        selectedIntolerance = el8.data.allergies.create(item);
    };
    var reactionMindreaderOpts = el8.appshared.mindreaderOpts.snomedCodes();
    reactionMindreaderOpts['selectFn'] = function(event, item) {
        selectedReaction = el8.data.snomedCodes.create(item);
    };
    reactionMindreaderOpts['formatSelected'] = function(item) {
        return item.description;
    }

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'manualIntoleranceName',
                selector: ':input[name="manualIntoleranceName"]',
                infoText: 'name of intolerance...',
                height: el8.util.consts.XL_FIELD_HEIGHT,
                mindreaderOpts: mindreaderOpts,
                maxLength: 255
            },
            {
                name: 'reaction',
                selector: ':input[name="reaction"]',
                infoText: 'reaction...',
                maxLength: 200
            },
            {
              name: 'reactionSnomedDescription',
              selector: ':input[name="reactionSnomedDescription"]',
              height: el8.util.consts.XL_FIELD_HEIGHT,
              infoText: 'reaction code...',
              mindreaderOpts: reactionMindreaderOpts
            },
            {
                name: 'severity',
                selector: ':input[name="severity"]'
            },
            {
                name: 'startDate',
                selector: ':input[name="startDate"]',
                infoText: 'e.g. YYYY',
                datePickerOpts: {}
            },
            {
                name: 'status',
                selector: ':input[name="status"]'
            }
        ]
    });

    var doSave = function(_form, addAnother) {
        if (!currPtIntolerance) {
            currPtIntolerance = el8.ptdata.ptIntolerances.create(form.getMapped(), true);
        } else {
            currPtIntolerance.populate(form.getMapped());
        }

        if (!currPtIntolerance.getManualIntoleranceName()) {
            el8.uiwidget.alert('Please enter a drug name.', form.getInfoField('manualIntoleranceName').getInputField());
            return;
        }

        if (selectedIntolerance) {
          currPtIntolerance.setIntoleranceId(selectedIntolerance.getId());
        }
        if (selectedReaction) {
          currPtIntolerance.setReactionSnomedId(selectedReaction.getId());
        }

        if (currPtIntolerance.getStartDate() && el8.util.datecompare.isAfterToday(currPtIntolerance.getStartDate())) {
            el8.uiwidget.alert('Please enter a start date in the past', form.getInfoField('startDate').getInputField());

        } else {
            el8.ptdata.ptIntolerances.saveItem(currPtIntolerance, false, {
                successCb: function() {
                    that.hide();
                    if (addAnother === true) { that.show(); }
                }
            });
        }
    };

    el8.appshared.form.buttons.addNonDraftDialogButtons(form, doSave, that);
    that.setForm(form);

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);
        spec = spec || {};
        currPtIntolerance = spec.ptIntolerance || null;
        if (currPtIntolerance) {
            that.setTitle('Edit Drug Intolerance');
            form.showDiscardChangesCaption();
            form.populate({
                'manualIntoleranceName': currPtIntolerance.getIntoleranceName(),
                'reaction': currPtIntolerance.getReaction(),
                'reactionSnomedDescription': currPtIntolerance.getReactionSnomedDescription(),
                'severity': currPtIntolerance.getSeverity(),
                'startDate': currPtIntolerance.getStartDate() ? currPtIntolerance.getStartDate().asString() : '',
                'status': currPtIntolerance.getStatus()
            });
        } else {
            that.setTitle('Add Drug Intolerance');
            form.showDiscardCaption();
        }
        form.initFocus();
    };

    var super_hide = that.hide;
    that.hide = function() {
        currPtIntolerance = null;
        selectedIntolerance = null;
        selectedReaction = null;
        super_hide.call(that);
    };

    return that;

})();

